import { InfoNotice } from '@/components/patterns/info-notice'
import StripeMigrationStatusNotice from './StripeMigrationStatusNotice'

export default function StripeMigrationProgressNotice({
  action,
  requiresAction = false,
  migration,
}) {
  const needsAccountAccess =
    migration?.target_disconnected ||
    (migration?.onboarding_complete && migration.can_onboard === false)
  return (
    <StripeMigrationStatusNotice
      migration={migration}
      action={action}
      fallback={
        migration?.ownership_blocked ? null : (
          <InfoNotice
            title={
              needsAccountAccess || requiresAction
                ? 'Your new Stripe account needs attention'
                : 'Your Stripe account is upgrading'
            }
            tone={needsAccountAccess ? 'warning' : requiresAction ? 'danger' : 'info'}
            action={action}
          >
            {needsAccountAccess
              ? 'Contact support to restore access to your new Stripe account. Your account upgrade has not been completed.'
              : requiresAction
                ? 'Stripe needs additional information before your upgrade can be completed. You’re still accepting payments through your existing Stripe account.'
                : 'You’re still accepting payments through your existing Stripe account while your new account is being upgraded. We’ll switch you over once everything is ready.'}
          </InfoNotice>
        )
      }
    />
  )
}
